var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"ProgressiveCircle",class:[{'is-active' : _vm.index === _vm.activeSlide}, _vm.classes],attrs:{"data-slide":_vm.index},on:{"click":function($event){return _vm.$emit('setActive', _vm.index)}}},[_c('span',{staticClass:"ProgressiveCircle__dot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }